"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOrganizationHelpers = void 0;
const constants_1 = require("./constants");
const types_1 = require("./types");
const getOrganizationHelpers = (type, products) => {
    var _a, _b, _c;
    if (constants_1.BANKS_PAGE_TYPE.includes(type) || ((_a = products === null || products === void 0 ? void 0 : products[types_1.OrganizationTypes.Bank]) === null || _a === void 0 ? void 0 : _a.includes(type))) {
        return constants_1.ORGANIZATIONS_DATA[types_1.OrganizationTypes.Bank];
    }
    if (constants_1.INSURANCE_COMPANY_PAGE_TYPE.includes(type) ||
        ((_b = products === null || products === void 0 ? void 0 : products[types_1.OrganizationTypes.Insurance]) === null || _b === void 0 ? void 0 : _b.includes(type))) {
        return constants_1.ORGANIZATIONS_DATA[types_1.OrganizationTypes.Insurance];
    }
    if (constants_1.MFO_PAGE_TYPE.includes(type)) {
        return constants_1.ORGANIZATIONS_DATA[types_1.OrganizationTypes.Mfo];
    }
    if (constants_1.SCHOOL_PAGE_TYPE.includes(type) ||
        ((_c = products === null || products === void 0 ? void 0 : products[types_1.OrganizationTypes.EducationalOrganization]) === null || _c === void 0 ? void 0 : _c.includes(type))) {
        return constants_1.ORGANIZATIONS_DATA[types_1.OrganizationTypes.EducationalOrganization];
    }
    if (constants_1.BROKER_PAGE_TYPE.includes(type)) {
        return constants_1.ORGANIZATIONS_DATA[types_1.OrganizationTypes.Broker];
    }
    if (constants_1.NPF_PAGE_TYPE.includes(type)) {
        return constants_1.ORGANIZATIONS_DATA[types_1.OrganizationTypes.Npf];
    }
    if (constants_1.LEASING_PAGE_TYPE.includes(type)) {
        return constants_1.ORGANIZATIONS_DATA[types_1.OrganizationTypes.Leasing];
    }
    if (constants_1.MARKETPLACE_PAGE_TYPE.includes(type)) {
        return constants_1.ORGANIZATIONS_DATA[types_1.OrganizationTypes.Marketplace];
    }
    if (constants_1.BANKRUPTCY_PAGE_TYPE.includes(type)) {
        return constants_1.ORGANIZATIONS_DATA[types_1.OrganizationTypes.Bankruptcy];
    }
    if (constants_1.UNIVERSITY_PAGE_TYPE.includes(type)) {
        return constants_1.ORGANIZATIONS_DATA[types_1.OrganizationTypes.University];
    }
    if (constants_1.OFFLINE_SCHOOL_PAGE_TYPE.includes(type)) {
        return constants_1.ORGANIZATIONS_DATA[types_1.OrganizationTypes.OfflineSchool];
    }
    if (constants_1.BOOKMAKER_PAGE_TYPE.includes(type)) {
        return constants_1.ORGANIZATIONS_DATA[types_1.OrganizationTypes.Bookmaker];
    }
    return {};
};
exports.getOrganizationHelpers = getOrganizationHelpers;
